<!--  -->
<template>
  <div class="box">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/', query: {tab: 0} }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>标准查询</el-breadcrumb-item>
    </el-breadcrumb>

    <div class="list">
        <div class="item">
            <img src="../../assets/img/biaozhunchaxun/one.png" class="left-img" alt="">
            <div class="right">
                <!-- <div class="title"></div> -->
                <a href="https://std.samr.gov.cn/" target="_blank" class="title">全国标准信息公共服务平台</a>
                <div class="direction">主管单位是国家市场监管总局和国家标准化管理委员会，可查询各类标准信息、国家标准制修订动态、各专业标准化技术委员会相关信息等内容。</div>
            </div>
        </div>
        <div class="item">
            <img src="../../assets/img/biaozhunchaxun/two.png" class="left-img" alt="">
            <div class="right">
                <a href="https://www.bz100.cn/" target="_blank" class="title">标准信息网（山东省标准馆）</a>
                <div class="direction">主办单位是山东省标准化研究院，可实现各类标准的查询以及提供各类标准化项目信息。</div>
            </div>
        </div>
        <div class="item">
            <img src="../../assets/img/biaozhunchaxun/three.png" class="left-img" alt="">
            <div class="right">
                <a href="http://www.lzbzzh.com/" target="_blank" class="title">标准智汇平台</a>
                <div class="direction">由淄博市企业联合会、淄博市企业家协会(简称市企两会)、淄博市标准化协会以及鲁中标准院共同建立的，鲁中标准院负责平台的日常运营工作。可实现标准知识普及、国家标准政策动态、标准检索系统、标准查重、团体标准数字化管理流程、 标准在线编辑器等功能。</div>
            </div>
        </div>
        <div class="item">
            <img src="../../assets/img/biaozhunchaxun/four.png" class="left-img" alt="">
            <div class="right">
                <a href="http://www.bzfw.org.cn/" target="_blank" class="title">淄博市标准化研究院</a>
                <div class="direction">主办单位是淄博市标准化研究院，综合性官方网站。</div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
    }
  }
}
</script>

<style lang="less" scoped>
    .list {
        margin: 10px 0 80px;
        .item {
            width: 100%;
            padding: 10px 20px;
            box-sizing: border-box;
            background-color: #fff;
            margin-bottom: 15px;

            display: flex;
            align-items: center;
            .left-img {
                width: 200px;
                height: 80px;
            }
            .right {
                flex: 1;
                margin-left: 30px;
                .title {
                    color: #027BFF;
                    cursor: pointer;
                    text-decoration: underline;
                }
                .direction {
                    line-height: 25px;
                    font-size: 14px;
                }
            }
        }
    }
</style>
